/** Product release notes for Artificiallly (newest first). */
export const RELEASES = [
  {
    version: '0.12.1',
    date: 'November 3, 2026',
    groups: [
      {
        heading: 'Animation',
        items: [
          'On Full body, Whole row walks every expression in that emotion. One expression starts as the locked figure, moves into that expression, then moves back out',
        ],
      },
    ],
  },
  {
    version: '0.12.0',
    date: 'November 3, 2026',
    groups: [
      {
        heading: 'Animation',
        items: [
          'A changed prompt can be saved. Generate keeps that wording, and it stays for that panel',
          'Liftoff starts from the locked side view, parked still, then moves into the locked liftoff illustration',
          'A Liftoff clip shows on its panel after it is generated',
        ],
      },
      {
        heading: 'Studio',
        items: [
          'The page opens before every picture is downloaded. Pictures load as they come into view',
        ],
      },
    ],
  },
  {
    version: '0.11.1',
    date: 'November 2, 2026',
    groups: [
      {
        heading: 'Animation',
        items: [
          'On a large screen, the cards in a year sit two across',
        ],
      },
      {
        heading: 'Library',
        items: [
          'On a large screen, the pictures fill the width of the page',
        ],
      },
    ],
  },
  {
    version: '0.11.0',
    date: 'November 2, 2026',
    groups: [
      {
        heading: 'Animation',
        items: [
          'Emotion, Full body, and Activity play from the locked picture. The prompt is on the panel, and Generate sends what is in the box',
          'A clip is silent and runs 8 seconds. The whole locked picture stays in the frame',
          'A wide Drive keeps the van the same size and uses the extra width for the road',
          'Older vans animate Top Down, Top Up, and In Flight',
          'The 2068 van animates Driving, Liftoff, and Flight. Its pictures come from the bible views',
        ],
      },
      {
        heading: 'Characters',
        items: [
          'A mannerism saved on one expression replaces that expression’s body on the still, on Full body, and on Activity. The emotion clip stays the face',
        ],
      },
      {
        heading: 'Studio',
        items: [
          'On a wide screen the section tabs stay on the page instead of scrolling sideways',
          'Library lists every picture and clip, newest first. A character’s pictures do not list the clips',
        ],
      },
    ],
  },
  {
    version: '0.10.0',
    date: 'October 27, 2026',
    groups: [
      {
        heading: 'Pages',
        items: [
          'A bible upload keeps each picture with the story it was made for. A new page changes later page numbers. A picture that matches no story stays off the page',
          'A page whose wording changed in this bible version is marked New prompt',
          'A seek-and-find page draws the objects. The van is not added as a header',
          'The objects for that page sit on the page. Ones with no page sit under Unassigned',
        ],
      },
      {
        heading: 'Characters',
        items: [
          'Deleting a character removes them from the page cast and from the generate list',
        ],
      },
      {
        heading: 'Pictures',
        items: [
          'On the live site, pictures load from storage',
          'Upsize to 300dpi, then Download 300dpi saves the PNG',
        ],
      },
      {
        heading: 'Generate',
        items: [
          'A dropped connection shows the underlying error, not only Connection error',
        ],
      },
    ],
  },
  {
    version: '0.9.5',
    date: 'October 22, 2026',
    groups: [
      {
        heading: 'Treatment',
        items: [
          'A year already in the chapter title is not printed again beside it',
          'The line under a treatment uses that chapter’s year, so a renamed year no longer stays on the old one',
          'Generate treatment stays connected until the sheet is finished, so the picture shows up without a refresh',
        ],
      },
      {
        heading: 'Studio',
        items: [
          'Buttons sit raised, settle when you hover, and press in while held or while that control is selected. Links stay flat',
        ],
      },
    ],
  },
  {
    version: '0.9.4',
    date: 'October 22, 2026',
    groups: [
      {
        heading: 'Treatment',
        items: [
          'The poster grid is gone. Each year has Generate treatment, and it draws one sheet from the pictures already saved',
          'Handwritten notes stay beside the characters. The van has one note, on the main scene. A few scenes from the story stay in the sheet',
          'The ink close-ups and the color row are gone. The bottom of the sheet is 5 to 7 other items from that year',
        ],
      },
      {
        heading: 'Studio',
        items: [
          'Working on this computer no longer copies a new picture, a lock, or a bible upload up to the live book',
        ],
      },
    ],
  },
  {
    version: '0.9.3',
    date: 'October 22, 2026',
    groups: [
      {
        heading: 'Studio',
        items: [
          'A character, a page scene, and a treatment Pick stay open or closed after you leave the page. They stay that way in this browser until you change them',
        ],
      },
    ],
  },
  {
    version: '0.9.2',
    date: 'October 22, 2026',
    groups: [
      {
        heading: 'Characters',
        items: [
          'Each character collapses. Show opens the prompt and pictures. Delete and Archive are icons at the top right while it is open, and Save sits at the bottom',
          'On a large screen the pictures sit to the right of the form, with room along the right edge',
        ],
      },
      {
        heading: 'Chapters',
        items: [
          'On a large screen, pages sit two across. Other items sit two across as well',
          'A page sends the locked turnaround first. A van or tree can also send up to two other locked pictures',
        ],
      },
      {
        heading: 'Treatment',
        items: [
          'Opening Pick puts the pictures on the left and the poster on the right',
          'The bottom of the poster shows that chapter’s seek-and-find pictures, and stops at 10',
        ],
      },
      {
        heading: 'Pictures',
        items: [
          'Lock is as wide as the picture. A locked picture shows a lock icon and a Locked chip. The icon asks before it unlocks',
          'Export is an icon on the other side of the Locked chip',
        ],
      },
    ],
  },
  {
    version: '0.9.1',
    date: 'October 22, 2026',
    groups: [
      {
        heading: 'Generate',
        items: [
          'A failed picture shows the provider error on that character or page. When OpenAI has no credits left, the card says so',
        ],
      },
      {
        heading: 'Bible',
        items: [
          'Uploading a bible keeps that version. Opening the site on this computer no longer puts an older copy back over it',
        ],
      },
      {
        heading: 'Expression engine',
        items: [
          'Each face has a copy icon. It copies the emotion, the label, the action units, and the face sentence, such as Happiness: Content (FACS AU6 AU12); A soft closed-mouth smile, eyes gently crinkled, relaxed brows.',
          'Emotion names such as Anticipation fit in the left box. The pointer stays an arrow until it is over the copy icon',
        ],
      },
    ],
  },
  {
    version: '0.9.0',
    date: 'October 22, 2026',
    groups: [
      {
        heading: 'Pages',
        items: [
          'Uploading a bible writes the expression lines from the file onto each page. An old sentence is replaced by the catalog citation, such as {Annie: happiness.content}, and the override stays on that same line',
        ],
      },
    ],
  },
  {
    version: '0.8.1',
    date: 'October 21, 2026',
    groups: [
      {
        heading: 'Expression engine',
        items: [
          'The expression matrix is its own page in the sidebar. Point at a cell to read the facial-action code and what the face is doing',
        ],
      },
      {
        heading: 'Pictures',
        items: [
          'The line under an open picture stays readable. An expression row lists the faces from left to right, such as Happiness: Content; Happy; Ecstatic; Wild; Calm',
        ],
      },
      {
        heading: 'Generate',
        items: [
          'Character and expression pictures keep the loose ink and watercolor: wobbly line, bare paper, and comic faces',
        ],
      },
      {
        heading: 'Sidebar',
        items: [
          'Archived projects sits under the project list',
        ],
      },
    ],
  },
  {
    version: '0.8.0',
    date: 'October 21, 2026',
    groups: [
      {
        heading: 'Characters',
        items: [
          'People have five more expression menus: interest, care, rest, anticipation, and longing. Each runs from a small face through a de-escalating one',
          'Dogs have two more menus: hopeful and subdued. The middle hopeful face is puppy eyes',
        ],
      },
      {
        heading: 'Pages',
        items: [
          'A page prompt can name a face with {Name: emotion.label}. Generate compiles that through the catalog for the person or dog in the chapter',
        ],
      },
    ],
  },
  {
    version: '0.7.2',
    date: 'October 20, 2026',
    groups: [
      {
        heading: 'Characters',
        items: [
          'Activity is its own menu, separate from the emotions. Pick an activity and an expression together. Generate uses both',
          'Turnaround is in Activity. Full body stays in the text field',
          'New activities: waving, hugging, talking, eating, looking back, hiding, reaching, and comforting',
          'The photo line is one sentence. No photo yet, and Generate includes it for this character and pages that cast them',
        ],
      },
      {
        heading: 'Bible',
        items: [
          'The uploaded bible is the page list. A story keeps its pictures when its number or chapter changes. A new page lands on the bible’s number. A page the bible no longer lists leaves the chapter, and the picture stays in Recent generations',
          'Each character, prop, chapter, and page has a small chip for the current bible. Matching words say that version even when they have not changed since an older one',
        ],
      },
      {
        heading: 'Documents',
        items: [
          'Documents lists the bible files you have uploaded, with download and remove. Recent generations are here. Upload the next bible in Settings',
        ],
      },
    ],
  },
  {
    version: '0.7.1',
    date: 'October 20, 2026',
    groups: [
      {
        heading: 'Characters',
        items: [
          'Each person and each dog has expression menus, three across. People get two rows: happiness, sadness, anger, fear, surprise, and disgust. Dogs get their own set',
          'Generate row is the first choice in each menu. Choosing it does not start the picture. The Generate button then draws that emotion as a left-to-right row of head studies, and it shows Generating… while it runs',
          'Any other choice is one face. Generate draws that face alone',
          'Save override keeps different wording for one face on this project',
        ],
      },
    ],
  },
  {
    version: '0.7.0',
    date: 'October 20, 2026',
    groups: [
      {
        heading: 'Treatment',
        items: [
          'Every era has a Treatment poster that fills itself in from your locked art — a hero scene, full-body and face studies, the van, the tree, the dog, and your Other pictures',
          'Generate the hero scene for an era, then approve and lock it like any other picture',
          'Choose exactly which locked pose fills any cell, or leave it on the newest automatically',
          'Export the finished poster as one landscape image at 300 dpi once the hero is locked',
        ],
      },
    ],
  },
  {
    version: '0.6.0',
    date: 'October 19, 2026',
    groups: [
      {
        heading: 'Pictures',
        items: [
          'Opening a picture fits the whole image on screen — up to 90% of the window, and smaller when a tall picture would run off the bottom. The viewer sits on a dark backdrop',
        ],
      },
      {
        heading: 'Chapters',
        items: [
          'A Jump to chapter bar on the project page takes you straight to a chapter',
        ],
      },
      {
        heading: 'Sign-in',
        items: [
          'Signing in opens the Google popup every time. The live site no longer gets stuck on a redirect page',
        ],
      },
    ],
  },
  {
    version: '0.5.5',
    date: 'October 18, 2026',
    groups: [
      {
        heading: 'Pictures',
        items: [
          'A locked picture stays in its chapter. Generating a chapter no longer sends locked pages or concept sheets from another chapter',
        ],
      },
    ],
  },
  {
    version: '0.5.4',
    date: 'October 18, 2026',
    groups: [
      {
        heading: 'Characters',
        items: [
          'Keep characters in their chapter is on for a book. A chapter generate uses only the characters locked to that chapter. Turn it off in Settings for a coloring book',
        ],
      },
      {
        heading: 'Bible',
        items: [
          'Uploading a bible sets each character title from the heading in the file. Pictures stay',
        ],
      },
    ],
  },
  {
    version: '0.5.3',
    date: 'October 18, 2026',
    groups: [
      {
        heading: 'Projects',
        items: [
          'Create New can take a Markdown Illustration Bible. The file list no longer hides .md files',
        ],
      },
    ],
  },
  {
    version: '0.5.2',
    date: 'October 18, 2026',
    groups: [
      {
        heading: 'Pictures',
        items: [
          'Thumbnails on Characters, Other, and Chapters load from the top of the page down, then left to right across each row',
        ],
      },
    ],
  },
  {
    version: '0.5.1',
    date: 'October 18, 2026',
    groups: [
      {
        heading: 'Characters',
        items: [
          'Turnaround draws a study sheet: front, back, and side, head studies, one accessory, one shoe, and a fabric swatch',
        ],
      },
    ],
  },
  {
    version: '0.5.0',
    date: 'October 18, 2026',
    groups: [
      {
        heading: 'Bible',
        items: [
          'Download changes saves a markdown file of character, other, and page prompts that differ from the bible',
        ],
      },
      {
        heading: 'Generate',
        items: [
          'Save scene stores the page text Generate draws',
        ],
      },
      {
        heading: 'Pictures',
        items: [
          'The line under the project title shows how many illustrations exist and how many are locked',
        ],
      },
    ],
  },
  {
    version: '0.4.0',
    date: 'October 17, 2026',
    groups: [
      {
        heading: 'Pictures',
        items: [
          'Opening a picture fills the screen. Close sits at the top right',
          'Arrows move through the other pictures in Characters, Other, or Chapters',
        ],
      },
      {
        heading: 'Bible',
        items: [
          'Uploading a bible adds a page when that chapter does not already have it. The year follows the heading on the page. Pictures stay',
        ],
      },
      {
        heading: 'Generate',
        items: [
          'Generate and 300dpi export finish when they take longer than a minute',
          'A failed request shows the error from the server',
        ],
      },
    ],
  },
  {
    version: '0.3.5',
    date: 'October 15, 2026',
    groups: [
      {
        heading: '2065',
        items: [
          'Twin A and Twin B are read from the bible and added to the 2065 cast',
        ],
      },
      {
        heading: 'Generate',
        items: [
          'A chapter page sends the latest locked picture for each person in that cast, plus a base photo when one is uploaded',
          'The same page sends the locked seek-and-find pictures that belong on that page',
          'A lock stays with that character or secret. A later bible save does not drop it, and it is not sent into another year',
        ],
      },
    ],
  },
  {
    version: '0.3.4',
    date: 'October 15, 2026',
    groups: [
      {
        heading: 'Characters',
        items: [
          'People have Face chips (smiling, smirking, laughing, frowning, surprised, mad) and Activity chips (building fire, pointing, chopping wood, sitting, laying down, cooking)',
        ],
      },
      {
        heading: 'Bible',
        items: [
          'An updated bible copies a character prompt or a page prompt when that text differs. Pictures stay attached',
          'A bible file in Documents updates those prompts instead of being filed as treatments',
        ],
      },
      {
        heading: 'Pictures',
        items: [
          'Locked and saved pictures load from Firestore, so they stay on the card after a deploy',
          'Approve & lock uses the stored picture',
          'Delete removes the picture from Firestore and Storage, so it does not come back',
        ],
      },
    ],
  },
  {
    version: '0.3.3',
    date: 'October 15, 2026',
    groups: [
      {
        heading: 'Generate',
        items: [
          'Production Generate runs through the Cloud Functions illustration API',
          'Page prompts lead with the required characters and where they sit, then the scene, then style',
        ],
      },
      {
        heading: 'Characters',
        items: [
          'Upload a base reference photo on a character. Generate sends that image with the prompt, including pages whose cast includes them',
        ],
      },
      {
        heading: 'Bible',
        items: [
          'Uploading an updated bible keeps existing generated pictures and the pages they belong to',
        ],
      },
    ],
  },
  {
    version: '0.3.2',
    date: 'October 15, 2026',
    groups: [
      {
        heading: 'Cloud projects',
        items: [
          'Project list and open fall back to Firestore + Storage when the Thor API is unreachable',
          'Adventure Awaits (and other local projects) sync to Firebase: sidebar meta in Firestore, full project.json in Storage',
        ],
      },
    ],
  },
  {
    version: '0.3.1',
    date: 'October 15, 2026',
    groups: [
      {
        heading: 'Bible pack v2',
        items: [
          'Consolidated bible ingest reads sections A–J from one markdown file (style, genealogy, eras, seek-and-find, page prompts)',
          'Page Generate sends the full §G fenced prompt when the page is marked complete',
          'Agent format template at docs/agent-bible-format-v2.md so uploads keep the parseable shape',
        ],
      },
      {
        heading: 'Sign-in and loaders',
        items: [
          'Login brand: Kip beside Artificiallly with Intelligent Illustration Studio under Artificiall on the y-descender plane',
          'Google Sign-In keeps the official light button and uses the 0.96 press scale outside overflow clipping',
          'Page and section loading uses the watercolor splotch loader instead of Ant Design Spin',
        ],
      },
    ],
  },
  {
    version: '0.3.0',
    date: 'October 15, 2026',
    groups: [
      {
        heading: 'Illustration studio',
        items: [
          'Projects rebuild from a typed pack into Characters, Other (seek-and-find), and Chapters → Pages',
          'Character cards support pose chips, Generate, multi-attempt galleries, and Approve & lock',
          'Page Generate assembles bible style prefixes, cast, Other secrets, overrides, and locked refs',
          'Locked page attempts export at 300dpi for print',
        ],
      },
      {
        heading: 'Generations',
        items: [
          'Unlock a locked image before delete — Unlock clears the continuity reference and keeps the attempt',
          'Delete removes the generation JSON/PNG (and 300dpi export if present) after unlock',
          'Approve, generate, unlock, and delete update the open section without remounting the whole project page',
        ],
      },
      {
        heading: 'Style and ops',
        items: [
          'Style prompts target bright clean white watercolor paper and reject yellow or cream grounds',
          'Illustration API stays up on Thor via a KeepAlive LaunchAgent on port 3002',
        ],
      },
    ],
  },
  {
    version: '0.2.0',
    date: 'October 15, 2026',
    groups: [
      {
        heading: 'Studio foundation',
        items: [
          'Multi-project create with Illustration Bible ingest',
          'Documents scan and pack rebuild entry points',
          'Admin provider settings for OpenAI image generation',
        ],
      },
    ],
  },
];
